import api from "./api";

// Resolve a quote/order customer to a real CRM person id before opening the
// Customer 360. Many quotes carry a stale (e.g. "PER-501") or missing personId,
// so we (1) trust a personId only if it actually resolves, then (2) fall back to
// an email lookup. Returns the canonical person id, or null if no record exists.
export async function resolveCrmPersonId({ personId, email }) {
  if (personId) {
    try {
      await api.get(`/crm/persons/${encodeURIComponent(personId)}`);
      return String(personId);
    } catch (_) {
      // stale / not found — fall through to email
    }
  }
  if (email) {
    try {
      const { data } = await api.get(`/crm/persons`, { params: { q: email, limit: 5 } });
      const items = data?.items || [];
      const lower = String(email).toLowerCase();
      const exact = items.find((p) => (p.email || "").toLowerCase() === lower);
      const hit = exact || items[0];
      if (hit?.id) return String(hit.id);
    } catch (_) {
      // ignore — no match
    }
  }
  return null;
}
